const palette = {
  black: "#000000",
  white: "#FFFFFF",
  blackTransparent: "#00000000",
  whiteTransparent: "#FFFFFF00",

  grey: {
    veryDark: "#333",
    dark: "#555",
    medium: "#B4B8B8",
    light: "#E6E6E6",
    veryLight: "#F8F8F8",
  },

  // Primary
  yellow: {
    light: "#ffd644",
    primary: "#FFF271",
  },

  green: {
    veryLight: "#D0FBD8",
    veryLighBackground: "#ECFCED",
    light: "#AFE4D0",
    primary: "#45C485",
    apple: "#A2E0C0",
    appleLight: "#CFEFDF",
    tertiary: "#45C485",
  },

  cream: { primary: "#F2EDE8" },

  // Secondary
  blue: {
    primary: "#A3FAEB",
    secondaryLight: "#CFFBF3",
  },

  red: { primary: "#FF704F" },

  pink: {
    primary: "#FFBDB8",
    primaryLight: "#F8DFDC",
    light: "#F1DEFF",
    veryLight: "#F8EEFF",
  },

  purple: { light: "#D9ACC3", veryLight: "#ECD5E1" },

  brown: { primary: "#CFB59C" },

  // UI Only
  orange: { light: "#FDE3A8" },
} as const;

export default palette;
